import React from "react";
import AsyncSelect from "react-select/async";
import { AlignCenter, AlignLeft, AlignRight, Button, Select, TileGroup, XClose } from "@opendate-app/setlist";

import { useBeefreeAddonIndexContext } from "./BeefreeAddonIndexContainer";

const containerStyle = {
  padding: 20,
  display: "flex",
  flexDirection: "column",
  gap: 12,
  color: "var(--sl-text-primary)",
  background: "var(--sl-bg-primary)",
  fontSize: 14,
};

const titleStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: 18,
  fontWeight: 600,
};

const subHeaderStyle = {
  color: "var(--sl-text-tertiary)",
  fontSize: 12,
  marginTop: 4,
  fontWeight: 400,
};

const sectionStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

const labelStyle = {
  fontWeight: 500,
  color: "var(--sl-text-secondary)",
};

const hintStyle = {
  color: "var(--sl-text-tertiary)",
  fontSize: 12,
};

const footerContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
};

const eventTypeItems = [
  { value: "upcoming", label: "Upcoming Event" },
  { value: "announced", label: "Just Announced" },
  { value: "justforyou", label: "Just For You" },
  { value: "specific", label: "Specific Event" },
];

const eventTypeHints = {
  upcoming: "Add the next upcoming events from your calendar.",
  announced: "Add just announced events from your calendar.",
  justforyou: "Add personalized event recommendations for each fan.",
  specific: "Search and select a specific event from your calendar.",
};

const layoutItems = [
  { value: "left", label: "Left", icon: AlignLeft },
  { value: "center", label: "Center", icon: AlignCenter },
  { value: "right", label: "Right", icon: AlignRight },
];

const BeefreeAddonIndex = () => {
  const {
    venueOwnerships,
    venueOwnership,
    setVenueOwnership,
    formState,
    setFormState,
    selectedEvent,
    setSelectedEvent,
    searchEvents,
    insertContent,
    closeModal,
  } = useBeefreeAddonIndexContext();

  const showsVenue = formState.eventType === "upcoming" || formState.eventType === "announced";
  const isEnterDisabled = (formState.eventType === "specific" && !selectedEvent) || (showsVenue && !venueOwnership);

  return (
    <div style={containerStyle}>
      <div style={titleStyle}>
        <div>
          Add Event
          <div style={subHeaderStyle}>Automatically add events from your Opendate calendar.</div>
        </div>
        <Button variant="tertiary" icon={XClose} aria-label="Close" onClick={closeModal} />
      </div>
      <div style={sectionStyle}>
        <div style={labelStyle}>Select the kind of event you want to include.</div>
        <TileGroup
          type="radio"
          columns={2}
          items={eventTypeItems}
          value={formState.eventType}
          onChange={(eventType) => {
            setFormState({ ...formState, eventType });
            setSelectedEvent(null);
          }}
        />
        <div style={hintStyle}>{eventTypeHints[formState.eventType]}</div>
      </div>
      {showsVenue && (
        <Select
          label="Venue"
          options={venueOwnerships.map((ownership) => ({ value: ownership.id, label: ownership.name }))}
          value={venueOwnership?.id ?? null}
          onChange={(id) => {
            setVenueOwnership(venueOwnerships.find((ownership) => ownership.id === id));
            setSelectedEvent(null);
          }}
        />
      )}
      {formState.eventType === "specific" && (
        <AsyncSelect
          aria-label="Search for an event"
          placeholder="Start typing to search for an event..."
          loadOptions={searchEvents}
          value={selectedEvent ? { value: selectedEvent.id, label: selectedEvent.label } : null}
          onChange={(option) => setSelectedEvent(option)}
          styles={{ control: (base) => ({ ...base, minHeight: 40 }) }}
          isClearable
        />
      )}
      <div style={sectionStyle}>
        <div style={labelStyle}>Choose a layout.</div>
        <TileGroup
          type="radio"
          columns={3}
          items={layoutItems}
          value={formState.align}
          onChange={(align) => setFormState({ ...formState, align })}
        />
      </div>
      <div style={footerContainerStyle}>
        <Button variant="primary" onClick={insertContent} disabled={isEnterDisabled}>
          Enter
        </Button>
      </div>
    </div>
  );
};

export default BeefreeAddonIndex;
